<template>

  <m-pay-layout>

    <template slot="links">
      <router-link v-if="hasAdminRole"
        :to="{ name: 'merchant', params: { merchantId: purchase.merchantId } }">
        <v-btn small flat color="secondary">
          Merchant
          <v-icon small right dark class="ml-1">store</v-icon>
        </v-btn>
      </router-link>

      <router-link :to="{ name: 'transactions', query: { f_purchaseId: purchase.id } }">
        <v-btn small flat color="secondary">
          Transactions
          <v-icon small right dark class="ml-1">playlist_add_check</v-icon>
        </v-btn>
      </router-link>

      <router-link :to="{ name: 'exchange-logs', query: { f_purchaseId: purchase.id } }">
        <v-btn small flat color="secondary">
          Exchange Logs
          <v-icon small right dark class="ml-1">repeat</v-icon>
        </v-btn>
      </router-link>

      <router-link v-if="hasAdminRole"
        :to="{ name: 'customer', params: { customerId: purchase.customerId } }">
        <v-btn small flat color="secondary">
          Customer
          <v-icon small right dark class="ml-1">person</v-icon>
        </v-btn>
      </router-link>
    </template>

    <v-layout :column="$vuetify.breakpoint.smAndDown">

      <v-flex class="mx-2 mb-4">
        <m-pay-generic-viewer
          title="Purchase Details"
          :bean="purchase"
          :beanProperties="viewableProperties"
          :statusClasses="purchaseStatusClasses"
          :formatters="tableFormatters"
          :roles="fieldRoles"
        >
        </m-pay-generic-viewer>
      </v-flex>

    </v-layout>
  </m-pay-layout>

</template>

<script>
import axios from 'axios';
import queries from '../utils/queries';
import roles from '../utils/user-roles';
import { purchaseStatusClasses } from '../utils/statuses';
import formatters from '../utils/formatters';
import MPayGenericViewer from './MPayGenericViewer';

export default {
  name: 'MPayPurchaseDetailsView',

  components: {
    MPayGenericViewer,
  },

  data: () => ({
    loading: false,
    purchase: {},
    viewableProperties: [
      'merchantName',
      'amount',
      'currency',
      'paymentInfo',
      'status',
      'requestDate',
      'expirationDate',
      'lastCallbackStatus',
      'externalId',
      'reasonCode',
      'reasonNote',
    ],
    fieldRoles: {
      merchantName: roles.READ_ANY_USER,
    },
    purchaseStatusClasses,
    formatters,
    tableFormatters: {
      amount: formatters.amount,
      requestDate: formatters.dateTime,
      expirationDate: formatters.dateTime,
    },
  }),

  computed: {
    hasAdminRole() {
      return this.$store.getters.hasAnyRole(roles.READ_ANY_USER);
    },
  },

  methods: {
    fetchPurchase() {
      this.loading = true;
      axios.get(queries.purchase(this.$route.params.purchaseId))
        .then((response) => {
          this.purchase = response.data;
          this.loading = false;
        })
        .catch((e) => {
          this.purchase = {};
          this.showError(e);
          this.loading = false;
        });
    },
  },

  mounted() {
    this.fetchPurchase();
  },

};
</script>



// WEBPACK FOOTER //
// src/components/MPayPurchaseDetailsView.vue